// extracted by mini-css-extract-plugin
export var parcelRow = "_uf-0";